import { render } from "./MyHeader.vue?vue&type=template&id=21a65830&scoped=true"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"

import "./MyHeader.vue?vue&type=style&index=0&id=21a65830&lang=less&scoped=true"

import exportComponent from "/Users/liuhaitao/ij_project/patent_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a65830"]])

export default __exports__